<template>
          <v-sheet width="100%" outlined class="ma-2">
<!--            {{tdata}}-->
            <v-row >
              <v-col cols="12">
                <v-btn v-show="!filtersVisible" dark elevation="0" small @click="filtersVisible = true"
                       style="text-transform: none" class="mx-3 my-2">
                  Filters
                  <v-icon small>mdi-chevron-double-right</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="2" xl="2" lg="2" v-if="filtersVisible">
                <v-sheet outlined rounded class="ma-3">
                  <v-sheet class="d-flex justify-space-between align-center ma-3" >
                    <span class="font-weight-bold">Filters</span>
                    <v-btn class="float-end"
                           dark elevation="0" small
                           style="text-transform: none"
                           @click="filtersVisible = false">
                      Hide
                      <v-icon small>mdi-chevron-double-left</v-icon>
                    </v-btn>
                  </v-sheet>

                  <!-- Filter Controls -->
                  <v-sheet class="ma-4">
                    <v-combobox v-model="selectedCancerType" :items="cancerTypes" outlined multiple dense clearable
                                label="Select Cancer Type"></v-combobox>
                    <v-combobox v-model="selectedPhenoCategory" :items="phenoCategories" outlined multiple dense clearable
                                label="Select Phenotype Category"></v-combobox>
                    <v-combobox v-model="selectedPhenotype" :items="phenotypes" outlined multiple dense clearable
                                label="Select Phenotype"></v-combobox>
                    <v-row no-gutters class="mt-4">
                      <v-col cols="12" md="12" lg="6" xl="6" sm="12">
                        <v-btn color="primary" class="mx-2" small dense @click="applyFilters">Apply</v-btn>
                      </v-col>
                      <v-col cols="6" md="12" lg="6" xl="6" sm="12">
                        <v-btn color="secondary" class="mx-2" small dense @click="resetFilters">Reset</v-btn>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-sheet>
              </v-col>

              <!-- Graph Containers -->
              <v-col :cols="filtersVisible ? 9 : 11">
                <v-row>
                  <v-col cols="12" md="12" lg="4" xl="4" sm="12">
                    <v-sheet class="pa-1" id="volcano-container"></v-sheet>
                  </v-col>
                  <v-col cols="12" md="12" lg="4" xl="4" sm="12">
                    <v-sheet class="pa-1"  id="scatter-container"></v-sheet>
                  </v-col>
                  <v-col cols="12" md="12" lg="4" xl="4" sm="12">
                    <v-sheet class="pa-1"  id="scatter-container2"></v-sheet>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Legend Section -->
              <v-col cols="1">
                <phenotype_legend></phenotype_legend>
              </v-col>
            </v-row>
            <v-row class="ma-4">
              <v-col cols="12">
                <v-card-title>
                  Table results:
                </v-card-title>
                <v-sheet max-height="800px">
                  <phenotype-table :filtered-data="filteredData"></phenotype-table>

                </v-sheet>
              </v-col>

            </v-row>
            <v-dialog v-model="showDetailCard" max-width="500">
                <v-card v-if="selectedPoint">
                  <v-card-title>
                    Association Detail
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeDetailCard">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text>
                    <div v-if="currentChartType === 'volcano'">

                      <div><b>Dataset:</b> {{ selectedPoint.dataset_name }}</div>
                      <div><b>Cancer Type:</b> {{ selectedPoint.cancer_type }}</div>
                      <div><b>Phenotype:</b> {{ selectedPoint.phenotype }}</div>
                      <div><b>Category:</b> {{ selectedPoint.pheno_category }}</div>

                      <div class="mt-2">
                        <b>PTM Association
                          <v-btn  class="ma-1 primary" x-small @click="viewAssociation">
                            View
                          </v-btn>
                        </b>
                        <div>Coefficient: {{ selectedPoint.pheno_ptm_val }}</div>
                        <div>p-value: {{ Math.abs(selectedPoint.pheno_ptm_pvalue)}}</div>
                        <div>-log10(p-value:): {{ Math.abs(selectedPoint.pheno_ptm_normpval) }}</div>
                      </div>


                    </div>
                    <div v-if="currentChartType === 'rna'">

                      <div><b>Dataset:</b> {{ selectedPoint.dataset_name }}</div>
                      <div><b>Cancer Type:</b> {{ selectedPoint.cancer_type }}</div>
                      <div><b>Phenotype:</b> {{ selectedPoint.phenotype }}</div>

                      <div class="mt-2">
                        <b>PTM Association
                          <v-btn class="ma-1 primary" x-small @click="viewAssociation">
                          View
                          </v-btn>
                        </b>
                        <div>Coefficient: {{ selectedPoint.pheno_ptm_val }}</div>
                        <div>p-value: {{ Math.abs(selectedPoint.pheno_ptm_pvalue)}}</div>
                        <div>-log10(p-value:): {{ Math.abs(selectedPoint.pheno_ptm_normpval) }}</div>
                      </div>

                      <div class="mt-2">
                        <b>RNA Association
                          <v-btn class="ma-1 primary" x-small @click="openGenePlot('RNA')">
                          View
                        </v-btn></b>
                        <div>Coefficient: {{ selectedPoint.pheno_rna_val }}</div>
                        <div>p-value: {{ Math.abs(selectedPoint.pheno_rna_pvalue)}}</div>
                        <div>-log10(p-value:): {{ Math.abs(selectedPoint.pheno_rna_normpval) }}</div>
                      </div>


                    </div>

                    <div v-if="currentChartType === 'protein'">

                      <div><b>Dataset:</b> {{ selectedPoint.dataset_name }}</div>
                      <div><b>Cancer Type:</b> {{ selectedPoint.cancer_type }}</div>
                      <div><b>Phenotype:</b> {{ selectedPoint.phenotype }}</div>

                      <div class="mt-2">
                        <b>PTM Association
                          <v-btn class="ma-1 primary" x-small @click="viewAssociation">
                          View
                        </v-btn>
                        </b>
                        <div>Coefficient: {{ selectedPoint.pheno_ptm_val }}</div>
                        <div>p-value: {{ Math.abs(selectedPoint.pheno_ptm_pvalue)}}</div>
                        <div>-log10(p-value): {{ Math.abs(selectedPoint.pheno_ptm_normpval) }}</div>
                      </div>

                      <div class="mt-2">
                        <b>Protein Asociation
                          <v-btn class="ma-1 primary" x-small @click="openGenePlot('protein')">
                            View
                          </v-btn>
                        </b>
                        <div>Coefficient: {{ selectedPoint.pheno_protein_val }}</div>
                        <div>p-value: {{ Math.abs(selectedPoint.pheno_protein_pvalue)}}</div>
                        <div>-log10(p-value): {{ Math.abs(selectedPoint.pheno_protein_normpval) }}</div>
                      </div>


                    </div>




                  </v-card-text>

                </v-card>
            </v-dialog>

          </v-sheet>



</template>

<script>
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';  // Optional, for offline exporting
import Phenotype_legend from "@/components/sub/phenotype_legend.vue";
import PhenotypeTable from "@/components/PhenotypeTable.vue";
Exporting(Highcharts);
OfflineExporting(Highcharts);  // Optional for offline exporting

export default {
  name: "Phenotype",
  components: {PhenotypeTable, Phenotype_legend},
  props: {
    tdata:{
      type:Array,
      required:true
    }
  },
  data() {
    return {
      filtersVisible: false,
      selectedCancerType: [],
      selectedPhenotype: [],
      selectedPhenoCategory: [],
      filteredData: [],
      selectedPoint: null,
      showDetailCard: false,
      chart: null,
      chart2: null,
      volcanoChart: null,
      colorMap: {
        BRCA: '#fd8cd5',
        CCRCC: '#ed7711',
        COAD: '#0728e4',
        GBM: "#62666b",
        HNSCC: "#89263b",
        LSCC: "#cb4763",
        LUAD: "#d3d3d3",
        OV: "#107d9d",
        PDAC: "#b80ec4",
        UCEC: "#f04688"
      },
    }
  },
  computed: {
    cancerTypes() {
      let filteredTdata = this.tdata;

      if (this.selectedPhenotype.length === 0 && this.selectedPhenoCategory.length === 0) {
        const types = filteredTdata.map(item => item.cancer_type);
        return [...new Set(types)];
      }
      else if (this.selectedPhenotype.length !== 0 && this.selectedPhenoCategory.length === 0) {
        filteredTdata = filteredTdata.filter(item => this.selectedPhenotype.includes(item.phenotype));
        const types = filteredTdata.map(item => item.cancer_type);
        return [...new Set(types)];
      }
      else if (this.selectedPhenotype.length === 0 && this.selectedPhenoCategory.length !== 0) {
        filteredTdata = filteredTdata.filter(item => this.selectedPhenoCategory.includes(item.pheno_category));
        const types = filteredTdata.map(item => item.cancer_type);
        return [...new Set(types)];
      }
      else {
        filteredTdata = filteredTdata.filter(item =>
            this.selectedPhenotype.includes(item.phenotype) && this.selectedPhenoCategory.includes(item.pheno_category)
        );
        const types = filteredTdata.map(item => item.cancer_type);
        return [...new Set(types)];
      }
    },

    phenotypes() {
      let filteredTdata = this.tdata;

      if (this.selectedCancerType.length === 0 && this.selectedPhenoCategory.length === 0) {
        const types = filteredTdata.map(item => item.phenotype);
        return [...new Set(types)];
      }
      else if (this.selectedCancerType.length !== 0 && this.selectedPhenoCategory.length === 0) {
        filteredTdata = filteredTdata.filter(item => this.selectedCancerType.includes(item.cancer_type));
        const types = filteredTdata.map(item => item.phenotype);
        return [...new Set(types)];
      }

      else if (this.selectedCancerType.length === 0 && this.selectedPhenoCategory.length !== 0) {
        filteredTdata = filteredTdata.filter(item => this.selectedPhenoCategory.includes(item.pheno_category));
        const types = filteredTdata.map(item => item.phenotype);
        return [...new Set(types)];
      }

      else {
        filteredTdata = filteredTdata.filter(item =>
            this.selectedCancerType.includes(item.cancer_type) && this.selectedPhenoCategory.includes(item.pheno_category)
        );
        const types = filteredTdata.map(item => item.phenotype);
        return [...new Set(types)];
      }
    },

    phenoCategories() {
      let filteredTdata = this.tdata;

      if (this.selectedCancerType.length === 0 && this.selectedPhenotype.length === 0) {
        const types = filteredTdata.map(item => item.pheno_category);
        return [...new Set(types)];
      }

      else if (this.selectedCancerType.length !== 0 && this.selectedPhenotype.length === 0) {
        filteredTdata = filteredTdata.filter(item => this.selectedCancerType.includes(item.cancer_type));
        const types = filteredTdata.map(item => item.pheno_category);
        return [...new Set(types)];
      }
      else if (this.selectedCancerType.length === 0 && this.selectedPhenotype.length !== 0) {
        filteredTdata = filteredTdata.filter(item => this.selectedPhenotype.includes(item.phenotype));
        const types = filteredTdata.map(item => item.pheno_category);
        return [...new Set(types)];
      }
      else {
        filteredTdata = filteredTdata.filter(item =>
            this.selectedCancerType.includes(item.cancer_type) && this.selectedPhenotype.includes(item.phenotype)
        );
        const types = filteredTdata.map(item => item.pheno_category);
        return [...new Set(types)];
      }
    }
  },
  methods: {
    openDetailCard(point) {
      this.selectedPoint = point;
      this.showDetailCard = true;
    },
    closeDetailCard() {
      this.showDetailCard = false;
      this.selectedPoint = null;
    },
    openGenePlot(datatype) {
      const p = this.selectedPoint;

      const url1 = `https://kb.linkedomics.org/plot/gene?gene=${p.substrate}&datatype=${datatype}&cohort=${p.cancer_type}&phenotype=${p.phenotype}`;
      const url2 = `https://kb.linkedomics.org/plot/gene_tn?gene=${p.substrate}&datatype=${datatype}&cohort=${p.cancer_type}`;

      const url=p.phenotype === 'clinical_tumor_vs_normal'
          ? url2
          : url1;
      window.open(url, '_blank');
    },
    viewAssociation() {
      const p = this.selectedPoint;
      const base = `https://kb.linkedomics.org/plot/phospho?protein=${p.harm_protein}&site=${p.harm_site}&cohort=${p.cancer_type}`;
      const url = p.phenotype === 'clinical_tumor_vs_normal'
          ? base
          : `${base}&phenotype=${p.phenotype}`;
      window.open(url, '_blank');
    },
    defineCustomSymbols() {
      const symbols = Highcharts.SVGRenderer.prototype.symbols;
      if (!symbols.wye) {
        symbols.wye = function (x, y, w, h) {
          const size = Math.min(w, h);
          const c = -0.5;
          const sqrt = Math.sqrt;
          const s = sqrt(3) / 2;
          const k = 1 / sqrt(12);
          const a = (k / 2 + 1) * 3;
          const r = sqrt((size * size) / a);
          const x0 = r / 2, y0 = r * k;
          const x1 = x0, y1 = r * k + r;
          const x2 = -x1, y2 = y1;

          const centerX = x + w / 2;
          const centerY = y + h / 2;

          return [
            'M', centerX + x0, centerY + y0,
            'L', centerX + x1, centerY + y1,
            'L', centerX + x2, centerY + y2,
            'L', centerX + (c * x0 - s * y0), centerY + (s * x0 + c * y0),
            'L', centerX + (c * x1 - s * y1), centerY + (s * x1 + c * y1),
            'L', centerX + (c * x2 - s * y2), centerY + (s * x2 + c * y2),
            'L', centerX + (c * x0 + s * y0), centerY + (c * y0 - s * x0),
            'L', centerX + (c * x1 + s * y1), centerY + (c * y1 - s * x1),
            'L', centerX + (c * x2 + s * y2), centerY + (c * y2 - s * x2),
            'Z'
          ];
        };
      }
    },

    applyFilters() {
      this.updateFilteredData();
    },
    resetFilters() {
      this.selectedCancerType = [];
      this.selectedPhenoCategory = [];
      this.selectedPhenotype = [];
      this.updateFilteredData();
    },
    updateFilteredData() {
      this.filteredData = this.tdata.filter(item => {
        const matchCancerType =
            this.selectedCancerType.length === 0 ||
            this.selectedCancerType.includes(item.cancer_type);

        const matchPhenotype =
            this.selectedPhenotype.length === 0 ||
            this.selectedPhenotype.includes(item.phenotype);

        const matchPhenoCategory =
            this.selectedPhenoCategory.length === 0 ||
            this.selectedPhenoCategory.includes(item.pheno_category);

        return matchCancerType && matchPhenotype && matchPhenoCategory;
      });

      this.$nextTick(() => {
        this.renderAllCharts();
      });
    },
    renderAllCharts() {
      this.renderChart();
      this.renderChart2();
      this.renderVolcanoPlot();
    },
    renderChart() {
      const seriesData = this.prepareSeriesData(
          'pheno_rna_normpval',
          'pheno_ptm_normpval'
      );

      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }

      this.chart = this.createChart(
          'scatter-container',
          '-log10(RNA-Phenotype correlation p-value)',
          '-log10(PTM-Phenotype correlation p-value)',
          seriesData,
          'Scatter Plot for Comparison of PTM-Phenotype vs RNA-Phenotype',
          'rna'
      );
    },
    renderChart2() {
      const seriesData = this.prepareSeriesData(
          'pheno_protein_normpval',
          'pheno_ptm_normpval'
      );

      if (this.chart2) {
        this.chart2.destroy();
        this.chart2 = null;
      }

      this.chart2 = this.createChart(
          'scatter-container2',
          '-log10(Protein-Phenotype correlation p-value)',
          '-log10(PTM-Phenotype correlation p-value)',
          seriesData,
          'Scatter Plot for Comparison of PTM-Phenotype vs Protein-Phenotype',
          'protein'
      );
    },

    prepareSeriesData(xKey, yKey) {
      const shape = {
        clinical: "cross",
        pathway: "square",
        "cell type": "triangle",
        genomic: "wye",
        mutation: "circle"
      };
      const groupedData = {};
      this.filteredData.forEach(item => {
        // if (item[yKey] === "NA" || item[xKey] < -16|| item[xKey] >16  || item[yKey] <-20) {
        if (item[yKey] === "NA") {
          return;
        }
        const cancerType = item.cancer_type;
        if (!groupedData[cancerType]) {
          groupedData[cancerType] = [];
        }
        groupedData[cancerType].push({
          x: parseFloat(item[xKey]),
          y: parseFloat(item[yKey]),
          marker: {
            symbol: shape[item.pheno_category],
            radius: (item[yKey] * item[xKey] < 0)
                ? (Math.abs(item[yKey]) > 3 ? 4 : 2)
                : (Math.abs(item[yKey]) > 3 && (Math.abs(item[yKey]) - Math.abs(item[xKey]) > 1))
                    ? 4 : 2
          },
          ...item
        });
      });
      return Object.keys(groupedData).map(cancerType => ({
        name: cancerType,
        data: groupedData[cancerType],
        color: this.colorMap[cancerType] || '#000000',
        marker: {
          symbol: 'circle',
          radius: 3
        }
      }));
    },
    renderVolcanoPlot() {
      const seriesData = this.prepareVolcanoSeriesData(
          'pheno_ptm_val',
          'pheno_ptm_normpval'
      );


      if (!this.volcanoChart) {
        this.volcanoChart = Highcharts.chart('volcano-container', {
          chart: {
            type: 'scatter',
            zoomType: 'xy'
          },
          custom: {
            componentRef: this
          },
          title: {
            text: 'Volcano Plot for PTM-Phenotype',
            style: {
              fontSize: '1.1rem',
              fontWeight: 'bold'
            }
          },
          xAxis: {
            title: {text: 'PTM-Phenotype correlation coefficient value'},
            gridLineWidth: 1,
            crosshair: true,
            plotLines: [
              {color: 'black', width: 1, value: 0, zIndex: 1}
            ]
          },
          yAxis: {
            title: {text: '-log10(PTM-Phenotype correlation p-value)'},
            gridLineWidth: 1,
            crosshair: true,
            plotLines: [
              {color: 'black', width: 1, value: 0},
              {color: 'gray', width: 1, value: 3, dashStyle: 'Dash', zIndex: 1}
            ]
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            scatter: {
              marker: {
                radius: 5,
                symbol: 'circle'
              }
            },
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function () {
                    const chartComponent =
                        this.series.chart.options.custom.componentRef;

                    chartComponent.currentChartType = 'volcano';
                    chartComponent.openDetailCard(this);
                  }
                }
              }
            }
          },
          tooltip: {
            formatter() {
              const phenotypeFormatted = this.point.phenotype.replace(/__/g, ': ');
              return `
                <b>${this.point.dataset_name}</b><br/>
                <b>${phenotypeFormatted}</b> <br/>

              `;
            }
          },
          series: seriesData,
          exporting: {
            enabled: true,
            sourceWidth: 600,
            sourceHeight: 600,
            scale: 8,
            buttons: {
              contextButton: {
                menuItems: ['downloadPNG', 'downloadSVG']
              }
            }
          }
        });

        return;
      }

      const chart = this.volcanoChart;

      while (chart.series.length) {
        chart.series[0].remove(false);
      }

      seriesData.forEach(s => {
        chart.addSeries(s, false);
      });

      chart.redraw();
    },
    // renderChart() {
    //   const seriesData = this.prepareSeriesData(
    //       'pheno_rna_normpval',
    //       'pheno_ptm_normpval'
    //   );
    //
    //   if (this.chart) {
    //     this.chart.destroy();
    //     this.chart = null;
    //   }
    //
    //   this.chart = this.createChart(
    //       'scatter-container',
    //       '-log10(RNA-Phenotype correlation p-value)',
    //       '-log10(PTM-Phenotype correlation p-value)',
    //       seriesData,
    //       'Scatter Plot for Comparison of PTM-Phenotype vs RNA-Phenotype'
    //   );
    // },
    // renderChart2() {
    //   const seriesData = this.prepareSeriesData(
    //       'pheno_protein_normpval',
    //       'pheno_ptm_normpval'
    //   );
    //
    //   if (this.chart2) {
    //     this.chart2.destroy();
    //     this.chart2 = null;
    //   }
    //
    //   this.chart2 = this.createChart(
    //       'scatter-container2',
    //       '-log10(Protein-Phenotype correlation p-value)',
    //       '-log10(PTM-Phenotype correlation p-value)',
    //       seriesData,
    //       'Scatter Plot for Comparison of PTM-Phenotype vs Protein-Phenotype'
    //   );
    // },

    // renderVolcanoPlot() {
    //   const seriesData = this.prepareVolcanoSeriesData(
    //       'pheno_ptm_val',
    //       'pheno_ptm_normpval'
    //   );
    //
    //   if (!this.volcanoChart) {
    //     this.volcanoChart = Highcharts.chart('volcano-container', {
    //       chart: {
    //         type: 'scatter',
    //         zoomType: 'xy'
    //       },
    //       title: {
    //         text: 'Volcano Plot for PTM-Phenotype',
    //         style: {
    //           fontSize: '1.1rem',
    //           fontWeight: 'bold'
    //         }
    //       },
    //       xAxis: {
    //         title: { text: 'PTM-Phenotype correlation coefficient value' },
    //         gridLineWidth: 1,
    //         crosshair: true,
    //         plotLines: [
    //           { color: 'black', width: 1, value: 0, zIndex: 1 }
    //         ]
    //       },
    //       yAxis: {
    //         title: { text: '-log10(PTM-Phenotype correlation p-value)' },
    //         gridLineWidth: 1,
    //         crosshair: true,
    //         plotLines: [
    //           { color: 'black', width: 1, value: 0 },
    //           { color: 'gray', width: 1, value: 3, dashStyle: 'Dash', zIndex: 1 }
    //         ]
    //       },
    //       legend: {
    //         enabled: false
    //       },
    //       plotOptions: {
    //         scatter: {
    //           marker: {
    //             radius: 5,
    //             symbol: 'circle'
    //           }
    //         },
    //         series: {
    //           cursor: 'pointer',
    //           point: {
    //             events: {
    //               click: function () {
    //                 const base = `https://kb.linkedomics.org/plot/phospho?protein=${this.harm_protein}&site=${this.harm_site}&cohort=${this.cancer_type}`;
    //                 const url = this.phenotype === 'clinical_tumor_vs_normal'
    //                     ? base
    //                     : `${base}&phenotype=${this.phenotype}`;
    //                 window.open(url, '_blank');
    //               }
    //             }
    //           }
    //         }
    //       },
    //       tooltip: {
    //         formatter() {
    //           const phenotypeFormatted = this.point.phenotype.replace(/__/g, ': ');
    //           return `
    //         <b>Dataset:</b> ${this.point.dataset_name}<br/>
    //         <b>Cancer Type:</b> ${this.point.cancer_type}<br/>
    //         <b>Phenotype:</b> ${phenotypeFormatted}<br/>
    //         <b>Category:</b> ${this.point.pheno_category}<br/>
    //         <b>Coefficient:</b> ${this.point.pheno_ptm_val}<br/>
    //         <b>Normalized p-value:</b> ${Math.abs(this.point.pheno_ptm_normpval)}
    //       `;
    //         }
    //       },
    //       series: seriesData,
    //       exporting: {
    //         enabled: true,
    //         sourceWidth: 600,
    //         sourceHeight: 600,
    //         scale: 8,
    //         buttons: {
    //           contextButton: {
    //             menuItems: ['downloadPNG', 'downloadSVG']
    //           }
    //         }
    //       }
    //     });
    //
    //     return;
    //   }
    //
    //   const chart = this.volcanoChart;
    //
    //   while (chart.series.length) {
    //     chart.series[0].remove(false);
    //   }
    //
    //   seriesData.forEach(s => {
    //     chart.addSeries(s, false);
    //   });
    //
    //   chart.redraw();
    // },
    prepareVolcanoSeriesData(xKey, yKey) {
      const shape = {
        clinical: "cross",
        pathway: "square",
        "cell type": "triangle",
        genomic: "wye",
        mutation: "circle"
      };

      const groupedData = {};
      this.filteredData.forEach(item => {
        const cancerType = item.cancer_type;
        if (!groupedData[cancerType]) {
          groupedData[cancerType] = [];
        }

        // Absolute value for y-axis
        const absNormPval = Math.abs(parseFloat(item[yKey]));

        groupedData[cancerType].push({
          x: parseFloat(item[xKey]),
          y: absNormPval,
          marker: {
            symbol: shape[item.pheno_category],
            radius: absNormPval > 3 ? 4 : 2,  // Adjust size based on pheno_ptm_normpval
          },
          ...item
        });
      });

      return Object.keys(groupedData).map(cancerType => ({
        name: cancerType,
        data: groupedData[cancerType],
        color: this.colorMap[cancerType] || '#000000',
      }));
    },
    createChart(containerId, xAxisTitle, yAxisTitle, seriesData, chartTitle,chartType) {
      const vm = this;
      return Highcharts.chart(containerId, {
        chart: {
          type: 'scatter',
          zoomType: 'xy',
          spacingLeft: 0,

          spacingRight: 0,
          events: {
            load: function () {
              const chart = this;

              let maxXPositive = -Infinity;
              let minXNegative = Infinity;
              let maxYPositive = -Infinity;
              let minYNegative = Infinity;

              seriesData.forEach(series => {
                series.data.forEach(point => {
                  if (point.x > 0 && point.x > maxXPositive) {
                    maxXPositive = point.x;
                  } else if (point.x < 0 && point.x < minXNegative) {
                    minXNegative = point.x;
                  }
                  if (point.y > 0 && point.y > maxYPositive) {
                    maxYPositive = point.y;
                  } else if (point.y < 0 && point.y < minYNegative) {
                    minYNegative = point.y;
                  }
                });
              });

              let minAbsVal = Math.min(
                  Math.abs(maxXPositive),
                  Math.abs(minXNegative),
                  Math.abs(maxYPositive),
                  Math.abs(minYNegative)
              );
              let minVal = minAbsVal

              let constant1 = 1;
              let constant2 = -1;


              if (minVal >= 3) {
                chart.renderer.path([
                  'M', chart.xAxis[0].toPixels(minVal), chart.yAxis[0].toPixels(minVal - constant1),
                  'L', chart.xAxis[0].toPixels(-minVal), chart.yAxis[0].toPixels(-minVal - constant1)
                ])
                    .attr({
                      'stroke-width': 1,  // Thinner line
                      stroke: 'gray',
                      dashstyle: 'dash'
                    })
                    .add();

                chart.renderer.path([
                  'M', chart.xAxis[0].toPixels(minVal), chart.yAxis[0].toPixels(minVal - constant2),
                  'L', chart.xAxis[0].toPixels(-minVal), chart.yAxis[0].toPixels(-minVal - constant2)
                ])
                    .attr({
                      'stroke-width': 1,  // Thinner line
                      stroke: 'gray',
                      dashstyle: 'dash'
                    })
                    .add();
              } else {
                console.log('minVal is less than 3, no lines drawn');
              }
            }
          },
        },
        title: {
          text: chartTitle,
          style: {
            fontSize: '1.1rem',
            fontWeight: 'bold'
          }
        },
        xAxis: {
          title: {text: xAxisTitle},
          gridLineWidth: 1,
          crosshair: true,
          plotLines: [
            {color: 'black', width: 1, value: 0, zIndex: 1},  // Center line
            // {color: 'gray', width: 1, value: 3, dashStyle: 'Dash', zIndex: 1},   // x = 3 dashed line
            // {color: 'gray', width: 1, value: -3, dashStyle: 'Dash', zIndex: 1}   // x = -3 dashed line
          ]
        },
        yAxis: {
          title: {text: yAxisTitle},
          gridLineWidth: 1,
          crosshair: true,
          plotLines: [
            {color: 'black', width: 1, value: 0, zIndex: 1},  // Center line
            {color: 'gray', width: 1, value: 3, dashStyle: 'Dash', zIndex: 1},   // y = 3 dashed line
            {color: 'gray', width: 1, value: -3, dashStyle: 'Dash', zIndex: 1}   // y = -3 dashed line
          ]
        },
        legend: {
          enabled: false  // Disable legend
        },

        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: function () {
                  vm.currentChartType = chartType;
                  vm.openDetailCard(this);
                }
              }
            }
          }
        },
        tooltip: {
          hideDelay: 50,
          formatter() {
            const phenotypeFormatted = this.point.phenotype.replace(/__/g, ': ');
            return `
              <b>${this.point.dataset_name}</b><br/>
              <b>${phenotypeFormatted}</b>
            `;
          }
        },
        series: seriesData,
        exporting: {
          enabled: true,
          sourceWidth: 600,
          sourceHeight: 600,
          scale: 8,
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadSVG']
            }
          }
        }
      });
    },
  },


    //   createChart(containerId, xAxisTitle, yAxisTitle, seriesData, chartTitle) {
  //     return Highcharts.chart(containerId, {
  //       chart: {
  //         type: 'scatter',
  //         zoomType: 'xy',
  //         spacingLeft: 0,
  //         spacingRight: 0,
  //         events: {
  //           load: function () {
  //             const chart = this;
  //
  //             let maxXPositive = -Infinity;
  //             let minXNegative = Infinity;
  //             let maxYPositive = -Infinity;
  //             let minYNegative = Infinity;
  //
  //             seriesData.forEach(series => {
  //               series.data.forEach(point => {
  //                 if (point.x > 0 && point.x > maxXPositive) {
  //                   maxXPositive = point.x;
  //                 } else if (point.x < 0 && point.x < minXNegative) {
  //                   minXNegative = point.x;
  //                 }
  //                 if (point.y > 0 && point.y > maxYPositive) {
  //                   maxYPositive = point.y;
  //                 } else if (point.y < 0 && point.y < minYNegative) {
  //                   minYNegative = point.y;
  //                 }
  //               });
  //             });
  //
  //             let minAbsVal = Math.min(
  //                 Math.abs(maxXPositive),
  //                 Math.abs(minXNegative),
  //                 Math.abs(maxYPositive),
  //                 Math.abs(minYNegative)
  //             );
  //             let minVal = minAbsVal
  //
  //             let constant1 = 1;
  //             let constant2 = -1;
  //
  //
  //             if (minVal >= 3) {
  //               chart.renderer.path([
  //                 'M', chart.xAxis[0].toPixels(minVal), chart.yAxis[0].toPixels(minVal - constant1),
  //                 'L', chart.xAxis[0].toPixels(-minVal), chart.yAxis[0].toPixels(-minVal - constant1)
  //               ])
  //                   .attr({
  //                     'stroke-width': 1,  // Thinner line
  //                     stroke: 'gray',
  //                     dashstyle: 'dash'
  //                   })
  //                   .add();
  //
  //               chart.renderer.path([
  //                 'M', chart.xAxis[0].toPixels(minVal), chart.yAxis[0].toPixels(minVal - constant2),
  //                 'L', chart.xAxis[0].toPixels(-minVal), chart.yAxis[0].toPixels(-minVal - constant2)
  //               ])
  //                   .attr({
  //                     'stroke-width': 1,  // Thinner line
  //                     stroke: 'gray',
  //                     dashstyle: 'dash'
  //                   })
  //                   .add();
  //             } else {
  //               console.log('minVal is less than 3, no lines drawn');
  //             }
  //           }
  //         },
  //       },
  //       title: {
  //         text: chartTitle,
  //         style: {
  //           fontSize: '1.1rem',
  //           fontWeight: 'bold'
  //         }
  //       },
  //       xAxis: {
  //         title: {text: xAxisTitle},
  //         gridLineWidth: 1,
  //         crosshair: true,
  //         plotLines: [
  //           {color: 'black', width: 1, value: 0, zIndex: 1},  // Center line
  //           // {color: 'gray', width: 1, value: 3, dashStyle: 'Dash', zIndex: 1},   // x = 3 dashed line
  //           // {color: 'gray', width: 1, value: -3, dashStyle: 'Dash', zIndex: 1}   // x = -3 dashed line
  //         ]
  //       },
  //       yAxis: {
  //         title: {text: yAxisTitle},
  //         gridLineWidth: 1,
  //         crosshair: true,
  //         plotLines: [
  //           {color: 'black', width: 1, value: 0, zIndex: 1},  // Center line
  //           {color: 'gray', width: 1, value: 3, dashStyle: 'Dash', zIndex: 1},   // y = 3 dashed line
  //           {color: 'gray', width: 1, value: -3, dashStyle: 'Dash', zIndex: 1}   // y = -3 dashed line
  //         ]
  //       },
  //       legend: {
  //         enabled: false  // Disable legend
  //       },
  //       plotOptions: {
  //         series: {
  //           cursor: 'pointer',
  //           point: {
  //             events: {
  //               click: function () {
  //                 if (this.phenotype === "clinical_tumor_vs_normal") {
  //                   const url = `https://kb.linkedomics.org/plot/phospho?protein=${this.harm_protein}&site=${this.harm_site}&cohort=${this.cancer_type}`;
  //                   window.open(url, '_blank');
  //                 } else {
  //                   const url = `https://kb.linkedomics.org/plot/phospho?protein=${this.harm_protein}&site=${this.harm_site}&cohort=${this.cancer_type}&phenotype=${this.phenotype}`;
  //                   window.open(url, '_blank');
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       },
  //       tooltip: {
  //         hideDelay: 50,
  //         formatter() {
  //           const phenotypeFormatted = this.point.phenotype.replace(/__/g, ': ');
  //           return `
  //         <b>&nbsp;Dateset name:</b>${this.point.dataset_name}<br/>
  //         <b>Cancer Type:</b> ${this.point.cancer_type}<br/>
  //         <b>Phenotype:</b> ${phenotypeFormatted}<br/>
  //         <b>Phenotype Category:</b> ${this.point.pheno_category}<br/>
  //         <b>PTM-Phenotype correlation:</b> <br/>
  //         &nbsp;&nbsp;coefficient: ${this.point.pheno_ptm_val} <br/>
  //         &nbsp;&nbsp;pvalue: ${this.point.pheno_ptm_pvalue} <br/>
  //         &nbsp;&nbsp;normalized_pvalue: ${this.point.pheno_ptm_normpval} <br/>
  //         <b>RNA-Phenotype correlation:</b> <br/>
  //         &nbsp;&nbsp;coefficient: ${this.point.pheno_rna_val} <br/>
  //         &nbsp;&nbsp;pvalue: ${this.point.pheno_rna_pvalue} <br/>
  //         &nbsp;&nbsp;normalized_pvalue: ${this.point.pheno_rna_normpval} <br/>
  //         <b>Protein-Phenotype correlation:</b> <br/>
  //         &nbsp;&nbsp;coefficient: ${this.point.pheno_protein_val} <br/>
  //         &nbsp;&nbsp;pvalue: ${this.point.pheno_protein_pvalue} <br/>
  //         &nbsp;&nbsp;normalized_pvalue: ${this.point.pheno_protein_normpval} <br/>
  //
  //       `;
  //         }
  //       },
  //       series: seriesData,
  //       exporting: {
  //         enabled: true,
  //         sourceWidth: 600,
  //         sourceHeight: 600,
  //         scale: 8,
  //         buttons: {
  //           contextButton: {
  //             menuItems: ['downloadPNG', 'downloadSVG']
  //           }
  //         }
  //       }
  //     });
  //   }
  // },
  mounted() {
    this.defineCustomSymbols();
    this.updateFilteredData()
  },
  beforeDestroy() {
    [this.chart, this.chart2, this.volcanoChart].forEach(c => {
      if (c && !c.destroyed) c.destroy();
    });
    this.chart = this.chart2 = this.volcanoChart = null;
  }

}
</script>

<style scoped>
#scatter-container {
  width: 90%;
  min-height: 400px;
}

#scatter-container2 {
  width: 90%;
  min-height: 400px;
}

#volcano-container {
  width: 90%;
  min-height: 400px;
}

.highcharts-legend .no-legend-click {
  pointer-events: none;
  cursor: default;
}

</style>
